var path = '/templates/zenclerk_s/sites/campaigns/create_button/campaign_create_button.html';
var html = "<div class=\"btn btn-primary btn-shadow\" uib-tooltip={{$ctrl.getTooltipMessage()}} tooltip-placement=bottom tooltip-enable=!$ctrl.isAllowedToCreate() ng-disabled=!$ctrl.isAllowedToCreate() ng-click=$ctrl.confirmCampaign()><ng-transclude>{{ 'sites.campaigns.createButton.createCampaign' | translate }}</ng-transclude></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/create_button/campaign_create_button.html
// module id = 1380
// module chunks = 0